import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, Injectable, NgModule} from '@angular/core';
import {
  AppContainerModule, AppContainerOptions, MydocmaServiceWorkerModule,
  MydocmaSystemReportModule, SystemReportService
} from '@mydocma/app-container';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MainComponent} from './main/main.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {AuthModule, AuthService, JwtAuthService} from '@mydocma/auth';
import {ProjectModule, ProjectStructureService} from '@mydocma/project';
import {CustomerModule} from '@mydocma/customer';
import {MediaQueryService, MediatorService} from '@mydocma/core';
import {FileType, ModuleTranslateLoader} from '@larscom/ngx-translate-module-loader';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DefaultUrlSerializer, UrlTree} from '@angular/router';
import {PopoverModule} from '@mydocma/component-library/src/lib/popover';
import {registerLocaleData} from '@angular/common';
import localeDE from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en-GB';
import {CustomMatIconModule} from '@mydocma/component-library/src/lib/custom-mat-icon';
import {CurrentFaultsSyncStateService} from '../../projects/mydocma/mm/src/lib/mm-faults/current-faults-sync-state.service';
import {PixCommonModule, PixComponentsModule} from '@mydocma/pix-common';
import {FaultPersistenceService} from '@docma-mm-core/fault/fault-persistence.service';
import {MmDbService} from '../../projects/mydocma/mm/src/lib/mm-db/mm-db-service';
import {FaultPatchService} from '@docma-mm-core/fault/patch/fault-patch-service';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {MatIconModule} from '@angular/material/icon';
import {PersonalizationService} from '@docma-mm-core/personalization/personalization.service';
import {GridItemSelectionService} from '../../projects/mydocma/mm/src/lib/mm-project-config/configs/services/grid-item-selection.service';
import {MmProjectService} from '../../projects/mydocma/mm/src/lib/mm-project/mm-project.service';
import {MmProjectLoaderService} from '../../projects/mydocma/mm/src/lib/mm-project/mm-project-loader.service';
import {MmStructureSyncService} from '../../projects/mydocma/mm/src/lib/mm-filter/structure/mm-structure-sync.service';
import {SchemaApiService} from '../../projects/mydocma/mm/src/lib/mydocma-common/schema/schema-api.service';
import {MmStructureSyncViewService} from '../../projects/mydocma/mm/src/lib/mm-filter/structure/mm-structure-sync-view.service';
import {MmProjectOfflineService} from '../../projects/mydocma/mm/src/lib/mm-project/mm-project-offline.service';
import {StructureService} from '@docma-mm-core/structure/structure.service';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {ContactService} from '@docma-mm-core/contact/contact.service';
import {FieldService} from '@docma-mm-core/field/field.service';
import {OrderService} from '@docma-mm-core/order/order.service';
import {ProjectHttpService} from '@docma-mm-core/project/project-http.service';
import {CraftService} from '@docma-mm-core/craft/craft.service';
import {UserDefinedApiService} from '@docma-mm-core/user-defined/user-defined-api.service';
import {StatusService} from '@docma-mm-core/status/status.service';
import {PermissionService} from '@docma-mm-core/permission/permission.service';
import {ClassificationService} from '@docma-mm-core/classification/classification.service';
import {DocumentTypeService} from '@docma-mm-core/document-type/document-type.service';
import {CompanyService} from '@docma-mm-core/company/company.service';
import {LayoutApiService} from '@docma-mm-core/layout/layout-api.service';
import {PlanService} from '@docma-mm-core/plan/plan.service';
import {ProjectSettingsService} from '@docma-mm-core/project-settings/project-settings.service';
import {AttributeApiService} from '@docma-mm-core/attribute/attribute-api.service';
import {AttributeGroupApiService} from '@docma-mm-core/attribute-group/attribute-group-api.service';
import {MydocmaDatePipe, MydocmaNumberPipe} from '@mydocma/common';
import {FaultService} from '@docma-mm-core/fault/fault.service';
import {FaultChangesCommitService} from '@docma-mm-core/fault/fault-changes-commit.service';
import {SyncFileService} from '@docma-mm-core/sync/sync-file.service';
import {ActivityDbService} from '@docma-mm-core/activity/db/activity-db.service';
import {AttachmentDbService} from '@docma-mm-core/attachment/attachment-db.service';
import {GroupDbService} from '@docma-mm-core/group/group-db.service';
import {FaultApiService} from '@docma-mm-core/fault/fault-api.service';
import {FaultDataLoaderService} from '@docma-mm-core/fault/fault-data-loader.service';
import {AttachmentDataLoaderService} from '@docma-mm-core/attachment/attachment-data-loader.service';
import {ActivityDataLoaderService} from '@docma-mm-core/activity/activity-data-loader.service';
import {FaultSyncService} from '@docma-mm-core/fault/sync/fault-sync.service';
import {AttachmentApiService} from '@docma-mm-core/attachment/attachment-api.service';
import {AttachmentSyncService} from '@docma-mm-core/attachment/attachment-sync.service';
import {ActivitySyncService} from '@docma-mm-core/activity/sync/activity-sync.service';
import {ActivityApiService} from '@docma-mm-core/activity/activity-api.service';
import {MmPlanEditService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-plans-view/mm-plan-view/services/mm-plan-edit.service';
import {MmProjectPermissionsService} from '../../projects/mydocma/mm/src/lib/mm-project/mm-project-permissions-service';
import {MmPlansFilterService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-plans-view/services/mm-plans-filter.service';
import {MmFilterService} from '../../projects/mydocma/mm/src/lib/mm-filter/mm-filter.service';
import {MmViewService} from '../../projects/mydocma/mm/src/lib/mm-view.service';
import {MmRoutingService} from '../../projects/mydocma/mm/src/lib/mm-routing/mm-routing.service';
import {MmProjectDownloadService} from '../../projects/mydocma/mm/src/lib/mm-project/mm-download.service';
import {KeywordService} from '@docma-core/keyword/keyword.service';
import {ProjectOfflineService} from '@docma-mm-core/project/project-offline.service';
import {GroupSyncService} from '@docma-mm-core/group/group-sync.service';
import {GroupApiService} from '@docma-mm-core/group/group-api.service';
import {MmFaultChangePageService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-view/mm-fault-right-pane/mm-fault-change-page.service';
import {MmFaultRightPaneService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-view/mm-fault-right-pane/mm-fault-right-pane.service';
import {MmFaultViewService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-fault/mm-fault-view.service';
import {ActivityService} from '@docma-mm-core/activity/activity.service';
import {AttachmentService} from '@docma-mm-core/attachment/attachment.service';
import {SearchIdService} from '@docma-mm-core/search-id/search-id.service';
import {DelayApiService} from '@docma-mm-core/delay/delay-api.service';
import {MmFaultsLoaderService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-loader.service';
import {MmLayoutStateService} from '../../projects/mydocma/mm/src/lib/mm-filter/layout/layout-state.service';
import {FaultLayoutApiService} from '@docma-mm-core/fault/fault-layout.api.service';
import {SelectionService} from '@mydocma/component-library/src/lib/selection';
import {
  MmFaultsSelectionService
} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-view/services/mm-faults-selection.service';
import {
  MmFaultsCountService
} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-view/services/mm-faults-count.service';
import {
  MmFaultsReportingService
} from '../../projects/mydocma/mm/src/lib/mm-reporting/faults/mm-faults-reporting.service';
import {MydocmaTaskModule, TaskFileDownloadService, TaskHttpService, TaskService} from '@mydocma/task';
import {MmPinsLoaderService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-pins-loader.service';
import {PinService} from '@docma-mm-core/pin/pin-service';
import {ColDefsService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-ag-grid/col-defs/col-defs.service';
import {MmFaultsSortingService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-view/services/mm-faults-sorting.service';
import {EmailDistributorApiService} from '@docma-mm-core/email-distributor/email-distributor-api.service';
import {LastUsedEntitiesService} from '@docma-mm-core/personalization/last-used-entities.service';
import {CoEventService} from '@mydocma/co';
import {CoCommonModule} from '@mydocma/co/src/lib/common';
import {LoggerFormatService, LoggerUserPrependFormatService, LoggerUserService, MydocmaLoggerModule} from '@mydocma/common/src/lib/logger';
import {MmLoggerUserService} from '../../projects/mydocma/mm/src/lib/mydocma-logger/mm-logger-user.service';
import {ProjectIntegrationApiService} from '@docma-mm-core/project-integration/project-integration.service';
import {MatMenuModule} from '@angular/material/menu';
import {FilterService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-ag-grid/filters/filter.service';
import {PoolService} from '@docma-mm-core/pool/pool.service';
import {RecentlyUsedPoolsService} from '../../projects/mydocma/mm/src/lib/mm-filter/pool/services/recently-used-pools.service';
import {ErrorService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-error.service';
import {FileApiService} from '../../projects/mydocma/mm/src/lib/files-common/file-api.service';
import {TaskApiService} from '../../projects/mydocma/mm/src/lib/tasks-common/task-api.service';
import {MatLegacySnackBarModule as MatSnackBarModule} from '@angular/material/legacy-snack-bar';
import {ScribbleDbService} from '@docma-mm-core/scribble/scribble-db.service';
import {ScribbleApiService} from '@docma-mm-core/scribble/scribble-api.service';
import {OfflineInterceptor} from 'projects/mydocma/mm/src/lib/mm-offline/interceptors/offline.interceptor';
import {OFFLINE_SERVICE} from 'projects/mydocma/mm/src/lib/mm-offline/interfaces/offline-service.token';
import {Capacitor} from '@capacitor/core';
import {CapacitorOfflineService} from 'projects/mydocma/mm/src/lib/mm-offline/services/capacitor-offline.service';
import {WebOfflineService} from 'projects/mydocma/mm/src/lib/mm-offline/services/web-offline.service';
import {MatDialogModule} from '@angular/material/dialog';
import {NativeModule} from '@mydocma/core/src/lib/native';
import {MydocmaInterceptorsModule} from '@mydocma/core/src/lib/interceptors';
import {MmLoadedFaultsSortingService} from '../../projects/mydocma/mm/src/lib/mm-faults/mm-loaded-faults-sorting.service';
import {PhaseApiService} from '@docma-mm-core/phase/phase-api.service';
import {IntegrationApiService} from '@docma-mm-core/integration/integration-api.service';
import {MmSystemReportService} from "../../projects/mydocma/mm/src/lib/system-report/mm-system-report.service";

@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    return super.parse(url.toLowerCase());
  }
}

export function createTranslateLoader(http: HttpClient) {
  const baseTranslateUrl = './assets/i18n';

  return new ModuleTranslateLoader(http, {
    modules: [
      {baseTranslateUrl, fileType: FileType.JSON},
      {moduleName: 'mm', baseTranslateUrl, fileType: FileType.JSON},
      {moduleName: 'project', baseTranslateUrl, fileType: FileType.JSON},
      {moduleName: 'customer', baseTranslateUrl, fileType: FileType.JSON},
      {moduleName: 'comp-lib', baseTranslateUrl, fileType: FileType.JSON},
      {moduleName: 'app-container', baseTranslateUrl, fileType: FileType.JSON},
      {moduleName: 'form', baseTranslateUrl, fileType: FileType.JSON},
      {moduleName: 'comp-task', baseTranslateUrl, fileType: FileType.JSON},
      {moduleName: 'TV', baseTranslateUrl, fileType: FileType.JSON},
      {moduleName: 'co', baseTranslateUrl, fileType: FileType.JSON},
      {moduleName: 'bim', baseTranslateUrl, fileType: FileType.JSON},
       {
         moduleName: 'pix-common',
         baseTranslateUrl,
         fileType: FileType.JSON
       }
    ],
  });
}

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
  ],
  imports: [
    MydocmaInterceptorsModule,
    MydocmaLoggerModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    AppContainerModule,
    MydocmaSystemReportModule.forRoot({
      provide: MmSystemReportService,
    }),
    PopoverModule,
    //  StoreModule.forRoot({}),
    AuthModule.forRoot(),
    CustomerModule.forRoot(),
    ProjectModule.forRoot(),
    PixCommonModule,
    PixComponentsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      },
    }),
    // ServiceWorkerModule.register('ngsw-worker.js', {enabled: true, registrationStrategy: 'registerWhenStable:30000' }),
    MydocmaServiceWorkerModule,
    MydocmaTaskModule,
    CustomMatIconModule,
    MatIconModule,
    TooltipModule,
    MatTooltipModule,
    CoCommonModule,
    MatMenuModule,
    MatSnackBarModule,
    MatDialogModule,
    NativeModule
  ],
  providers: [
    AppContainerOptions,
    {
      // Use existing logger user service
      provide: LoggerUserService,
      useClass: MmLoggerUserService
    },
    {
      provide: LoggerFormatService,
      useClass: LoggerUserPrependFormatService,
    },
    MediatorService,
    MediaQueryService,
    CurrentFaultsSyncStateService,
    PersonalizationService,
    LastUsedEntitiesService,
    FaultPersistenceService,
    MmDbService,
    FaultPatchService,
    GridItemSelectionService,

    MmProjectService,
    MmProjectLoaderService,
    SchemaApiService,
    MmStructureSyncService,
    MmStructureSyncViewService,
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [MmStructureSyncService, MmStructureSyncViewService],
      multi: true,
    },
    MmProjectOfflineService,
    StructureService,
    ConfigService,

    ProjectHttpService,
    ContactService,
    FieldService,
    OrderService,
    CraftService,
    UserDefinedApiService,
    StatusService,
    PermissionService,
    ClassificationService,
    DocumentTypeService,
    PhaseApiService,
    IntegrationApiService,
    CompanyService,
    LayoutApiService,
    PoolService,
    PlanService,
    ProjectSettingsService,
    AttributeApiService,
    AttributeGroupApiService,
    DelayApiService,
    SearchIdService,
    MydocmaDatePipe,
    MydocmaNumberPipe,
    FaultService,
    FaultChangesCommitService,
    SyncFileService,
    ActivityDbService,
    AttachmentDbService,
    ScribbleDbService,
    GroupDbService,
    FaultApiService,
    FileApiService,
    TaskApiService,
    FaultDataLoaderService,
    AttachmentDataLoaderService,
    ActivityDataLoaderService,
    FaultSyncService,
    ErrorService,
    AttachmentApiService,
    AttachmentSyncService,
    ActivitySyncService,
    ActivityApiService,
    ScribbleApiService,
    EmailDistributorApiService,
    MmPlanEditService,
    MmPlansFilterService,
    MmProjectPermissionsService,
    MmPlansFilterService,
    MmFilterService,
    MmViewService,
    MmRoutingService,
    MmProjectDownloadService,
    KeywordService,
    ProjectOfflineService,
    GroupSyncService,
    GroupApiService,
    MmFaultChangePageService,
    MmFaultRightPaneService,
    MmFaultViewService,
    ActivityService,
    AttachmentService,
    MmLoadedFaultsSortingService,
    MmFaultsLoaderService,
    MmLayoutStateService,
    FaultLayoutApiService,
    { provide: SelectionService, useClass: MmFaultsSelectionService },
    MmFaultsCountService,
    MmFaultsReportingService,
    MmPinsLoaderService,
    PinService,
    ColDefsService,
    MmFaultsSortingService,
    FilterService,
    ProjectStructureService,

    CoEventService,
    ProjectIntegrationApiService,
    { provide: JwtAuthService, useExisting: AuthService },
    RecentlyUsedPoolsService,
    {provide: HTTP_INTERCEPTORS, useClass: OfflineInterceptor, multi: true},
    {provide: OFFLINE_SERVICE, useClass: Capacitor.isNativePlatform() ? CapacitorOfflineService : WebOfflineService}
  ],
  bootstrap: [AppComponent]
})

export class AppModule {

  constructor(private translate: TranslateService) {
    // register locales data for languages
    // important for date format
    registerLocaleData(localeDE, 'de');
    localeEN[10][1] = 'yyyy-MM-dd';
    registerLocaleData(localeEN, 'en');
    //

    this.translate.addLangs(['en', 'de']);
    this.translate.setDefaultLang('de');
    this.translate.use('de');
  }

}
